import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Spin } from 'antd';
import RefillATMAddEdit from './add_edit';

class RefillATMAEdit extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
       edit_data:{},
       edit_id:this.props.edit_id,
       loaded:false
    };

    this.get_detail=RESTExecutor.detail().config({
      label:'atm_refill_detail',
  }).forId(this.props.edit_id).callbacks((success)=>{
    let d=success.result??{};
    delete d['image'];
    d={
      ...d,
      ...d?.deno_details
    }
      this.setState({
          edit_data:d,
          loaded:true
      })
  }).connect(props.domains.activity);


    if(this.props.edit_id){
   this.get_detail.execute()
  }   
  };
  
render() {
    const {loaded,edit_data,edit_id}=this.state;
    if(!loaded){
        return <center><Spin/></center>
    }

  return (
    <div> 
        <RefillATMAddEdit 
        key={`-${edit_id}`}
        edit_id={edit_id}
        edit_data={edit_data}
        onRefresh={()=>{
            this.get_detail.execute()
        }}

        onClose={this.props.onClose}
        onRefreshClose={this.props.onRefreshClose}
        />
      </div>
  );
}

componentDidUpdate = (prevProps) => {
  if ( this.props.edit_id !== prevProps.edit_id) {

      this.setState({
          edit_id: this.props.edit_id,
          loaded:false
      })
      this.get_detail.forId(this.props.edit_id).execute();


  };
}
}
export default withDomains(RefillATMAEdit,'activity');
